import React from 'react';
import { Header } from './Header';
import { HeroSection } from './HeroSection';
import { RecentProjects } from './RecentProjects';
import { ActionButtons } from './ActionButtons';

import { Footer } from './Footer';

export const WelcomeScreen: React.FC = () => {
  return (
    <div className="flex flex-col h-screen bg-gray-900 text-white">
      <Header />
      <main className="flex-1 overflow-auto px-8 py-6 flex items-center justify-center">
        <div className="max-w-4xl w-full space-y-8">
          <HeroSection />
          <RecentProjects />
          <ActionButtons />

        </div>
      </main>
      <Footer />
    </div>
  );
};
